import React, { useEffect, useState, useRef } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast, sortProjects } from "../CustomFunctions";
import { saveAs } from "file-saver";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import "jspdf-autotable";
import { axiosInstance2 } from "../../config/axiosInstance";
import * as XLSX from "xlsx";
// import { handleErrorToast } from "../CustomFunctions";
import Select, { components } from "react-select";
import {
  AddwithWhiteCircle,
  CheckGreen,
  DeleteDustbin,
  DropdownArrow,
  PDFIcon,
  UpdatePencil,
} from "../AllSvg";

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian } from "../CustomFunctions";

// ! *************** Sector Crud Models Start ***************

const AddJvPartner = ({ getJvPartner, JvPartnerData }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormData({
      priority_order: "",
      partner_name: "",
      sector: "",
      ops_poc: "",
      email: "",
      contact_no: "",
      senior_poc: "",
      senior_contact_no: "",
      internal_poc: "",
      tncs: "",
      remark: "",
    });
    setShow(false);
  };
  const handleShow = () => {
    getSubCompany();
    const nextPriority = (JvPartnerData?.length || 0) + 1;

    setFormData((prev) => ({
      ...prev,
      priority_order: nextPriority,
    }));
    setShow(true);
  };
  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const [formData, setFormData] = useState({
    priority_order: "",
    partner_name: "",
    sector: "",
    ops_poc: "",
    email: "",
    contact_no: "",
    senior_poc: "",
    senior_contact_no: "",
    internal_poc: "",
    tncs: "",
    remark: "",
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = ["partner_name", "sector", "email"];

    requiredFields.forEach((field) => {
      console.log(formData[field]);
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    console.log(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.post(
          `${BASE_URL}/siteproject/jvpartnerbd/`,
          formData,
        );

        if (res.status === 200 || res.status === 201) {
          await getJvPartner();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("JvPartner added successfully!");
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add JvPartner!");
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
        console.error(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    } else {
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const finalValue = typeof value === "string" ? value.trim() : value; // ✅ safely handle arrays
    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    // Optional: clear errors on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const [subcompanyList, setSubCompanyList] = useState([]);
  const getSubCompany = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSubCompanyList(response.data);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <button title="Add JvPartner" className="upload-svg" onClick={handleShow}>
        <AddwithWhiteCircle /> JvPartner
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Add JvPartner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">
              {/* Priority Order */}
              <div className="flex-column">
                <label
                  htmlFor="priority_order"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Priority Order"
                >
                  Priority Order <span className="required">*</span>
                </label>
                <input
                  placeholder="Priority Order"
                  title="Priority Order"
                  type="text"
                  name="priority_order"
                  onChange={handleInputChange}
                  value={formData.priority_order}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Partner Name */}
              <div className="flex-column">
                <label
                  htmlFor="partner_name"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Partner Name"
                >
                  Partner Name<span className="required">*</span>
                </label>
                <input
                  placeholder="Partner Name"
                  title="Partner Name"
                  type="text"
                  name="partner_name"
                  onChange={handleInputChange}
                  value={formData.partner_name}
                  className={`form-input font-weight400 font-size-subheading form-input-background ${errors.partner_name
                    ? "error"
                    : inputState.partner_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.partner_name && (
                  <span className="error-message font-size-text">
                    {errors.partner_name}
                  </span>
                )}
              </div>

              {/* Sector */}
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block" }}
              >
                <label className="form-labels font-weight500 font-size-subheading">
                  Sector <span className="required">*</span>
                </label>
                <br />
                <Select
                  options={[
                    { value: "Highway", label: "Highway" },
                    { value: "Railway", label: "Railway" },
                    { value: "Metro", label: "Metro" },
                    { value: "Water", label: "Water" },
                    { value: "Ropeway", label: "Ropeway" },
                    { value: "Building", label: "Building" },
                    { value: "Other", label: "Other" },
                  ]}
                  isMulti
                  value={
                    Array.isArray(formData.sector)
                      ? formData.sector.map((item) => ({
                        value: item,
                        label: item,
                      }))
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const values = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];
                    handleInputChange({
                      target: { name: "sector", value: values },
                    });
                  }}
                  placeholder="Select Sectors"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                />
                <br />
                {errors.sector && (
                  <span className="error-message">{errors.sector}</span>
                )}
              </div>

              {/* Ops POC */}
              <div className="flex-column">
                <label
                  htmlFor="ops_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Ops POC"
                >
                  Ops POC
                </label>
                <input
                  placeholder="Ops POC"
                  title="Ops POC"
                  type="text"
                  name="ops_poc"
                  onChange={handleInputChange}
                  value={formData.ops_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Email */}
              <div className="flex-column">
                <label
                  htmlFor="email"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Email Id"
                >
                  Email Id <span className="required">*</span>
                </label>
                <input
                  placeholder="Email Id"
                  title="Email Id"
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
                {errors.email && (
                  <span className="error-message font-size-text">
                    {errors.email}
                  </span>
                )}
              </div>

              {/* Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Contact No."
                >
                  Contact No
                </label>
                <input
                  placeholder="Contact No."
                  title="Contact No."
                  type="text"
                  name="contact_no"
                  onChange={handleInputChange}
                  value={formData.contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior POC */}
              <div className="flex-column">
                <label
                  htmlFor="senior_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior POC"
                >
                  Senior POC
                </label>
                <input
                  placeholder="Senior POC"
                  title="Senior POC"
                  type="text"
                  name="senior_poc"
                  onChange={handleInputChange}
                  value={formData.senior_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="senior_contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior Contact No."
                >
                  Senior Contact No
                </label>
                <input
                  placeholder="Senior Contact No."
                  title="Senior Contact No."
                  type="text"
                  name="senior_contact_no"
                  onChange={handleInputChange}
                  value={formData.senior_contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Internal POC */}
              <div className="flex-column">
                <label
                  htmlFor="internal_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Internal POC"
                >
                  Internal POC
                </label>
                <input
                  placeholder="Internal POC"
                  title="Internal POC"
                  type="text"
                  name="internal_poc"
                  onChange={handleInputChange}
                  value={formData.internal_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* TnCs */}
              <div className="flex-column">
                <label
                  htmlFor="tncs"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="TnCs"
                >
                  TnCs
                </label>
                <textarea
                  placeholder="Terms and Conditions"
                  title="TnCs"
                  name="tncs"
                  onChange={handleInputChange}
                  value={formData.tncs}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>

              {/* Remark */}
              <div className="flex-column">
                <label
                  htmlFor="remark"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Remark"
                >
                  Remark
                </label>
                <textarea
                  placeholder="Remark"
                  title="Remark"
                  name="remark"
                  onChange={handleInputChange}
                  value={formData.remark}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>
            </div>
          </form>

          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              Add
            </button>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateJvPartner = ({ i, getJvPartner }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormData({
      priority_order: "",
      partner_name: "",
      sector: "",
      ops_poc: "",
      email: "",
      contact_no: "",
      senior_poc: "",
      senior_contact_no: "",
      internal_poc: "",
      tncs: "",
      remark: "",
    });
    setShow(false);
  };
  const handleShow = () => {
    getSubCompany();
    setFormData(i);
    setShow(true);
  };
  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const [formData, setFormData] = useState({
    priority_order: "",
    partner_name: "",
    sector: "",
    ops_poc: "",
    email: "",
    contact_no: "",
    senior_poc: "",
    senior_contact_no: "",
    internal_poc: "",
    tncs: "",
    remark: "",
  });

  // console.log(formData.JvPartner_type)

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      "partner_name",
      "sector",
      "email",

      // formData.JvPartner_type === "Monthbywise" ? "month" : null,
      // formData.JvPartner_type === "Monthbywise" ? "year" : null,
      // formData.JvPartner_type === "ProjectbyWise" ? "project" : null,
      // formData.JvPartner_type === "ProjectbyWise" ? "employee" : null,
    ];

    requiredFields.forEach((field) => {
      console.log(formData[field]);
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    console.log(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/jvpartnerbd/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getJvPartner();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("JvPartner Updated successfully!");
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add JvPartner!");
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    } else {
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const finalValue = typeof value === "string" ? value.trim() : value; // ✅ safely handle arrays
    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    // Optional: clear errors on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const [subcompanyList, setSubCompanyList] = useState([]);
  const getSubCompany = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSubCompanyList(response.data);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <button
        title="Edit JvPartnerDetails"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />{" "}
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Update JvPartner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">
              {/* Priority Order */}
              <div className="flex-column">
                <label
                  htmlFor="priority_order"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Priority Order"
                >
                  Priority Order <span className="required">*</span>
                </label>
                <input
                  placeholder="Priority Order"
                  title="Priority Order"
                  type="text"
                  name="priority_order"
                  onChange={handleInputChange}
                  value={formData.priority_order}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Partner Name */}
              <div className="flex-column">
                <label
                  htmlFor="partner_name"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Partner Name"
                >
                  Partner Name<span className="required">*</span>
                </label>
                <input
                  placeholder="Partner Name"
                  title="Partner Name"
                  type="text"
                  name="partner_name"
                  onChange={handleInputChange}
                  value={formData.partner_name}
                  className={`form-input font-weight400 font-size-subheading form-input-background ${errors.partner_name
                    ? "error"
                    : inputState.partner_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.partner_name && (
                  <span className="error-message font-size-text">
                    {errors.partner_name}
                  </span>
                )}
              </div>

              {/* Sector */}
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block" }}
              >
                <label className="form-labels font-weight500 font-size-subheading">
                  Sector <span className="required">*</span>
                </label>
                <br />
                <Select
                  options={[
                    { value: "Highway", label: "Highway" },
                    { value: "Railway", label: "Railway" },
                    { value: "Metro", label: "Metro" },
                    { value: "Water", label: "Water" },
                    { value: "Ropeway", label: "Ropeway" },
                    { value: "Building", label: "Building" },
                    { value: "Other", label: "Other" },
                  ]}
                  isMulti
                  value={
                    Array.isArray(formData.sector)
                      ? formData.sector.map((item) => ({
                        value: item,
                        label: item,
                      }))
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const values = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];
                    handleInputChange({
                      target: { name: "sector", value: values },
                    });
                  }}
                  placeholder="Select Sectors"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                />
                <br />
                {errors.sector && (
                  <span className="error-message">{errors.sector}</span>
                )}
              </div>

              {/* Ops POC */}
              <div className="flex-column">
                <label
                  htmlFor="ops_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Ops POC"
                >
                  Ops POC
                </label>
                <input
                  placeholder="Ops POC"
                  title="Ops POC"
                  type="text"
                  name="ops_poc"
                  onChange={handleInputChange}
                  value={formData.ops_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Email */}
              <div className="flex-column">
                <label
                  htmlFor="email"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Email Id"
                >
                  Email Id <span className="required">*</span>
                </label>
                <input
                  placeholder="Email Id"
                  title="Email Id"
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
                {errors.email && (
                  <span className="error-message font-size-text">
                    {errors.email}
                  </span>
                )}
              </div>

              {/* Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Contact No."
                >
                  Contact No
                </label>
                <input
                  placeholder="Contact No."
                  title="Contact No."
                  type="text"
                  name="contact_no"
                  onChange={handleInputChange}
                  value={formData.contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior POC */}
              <div className="flex-column">
                <label
                  htmlFor="senior_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior POC"
                >
                  Senior POC
                </label>
                <input
                  placeholder="Senior POC"
                  title="Senior POC"
                  type="text"
                  name="senior_poc"
                  onChange={handleInputChange}
                  value={formData.senior_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="senior_contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior Contact No."
                >
                  Senior Contact No
                </label>
                <input
                  placeholder="Senior Contact No."
                  title="Senior Contact No."
                  type="text"
                  name="senior_contact_no"
                  onChange={handleInputChange}
                  value={formData.senior_contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Internal POC */}
              <div className="flex-column">
                <label
                  htmlFor="internal_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Internal POC"
                >
                  Internal POC
                </label>
                <input
                  placeholder="Internal POC"
                  title="Internal POC"
                  type="text"
                  name="internal_poc"
                  onChange={handleInputChange}
                  value={formData.internal_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* TnCs */}
              <div className="flex-column">
                <label
                  htmlFor="tncs"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="TnCs"
                >
                  TnCs
                </label>
                <textarea
                  placeholder="Terms and Conditions"
                  title="TnCs"
                  name="tncs"
                  onChange={handleInputChange}
                  value={formData.tncs}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>

              {/* Remark */}
              <div className="flex-column">
                <label
                  htmlFor="remark"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Remark"
                >
                  Remark
                </label>
                <textarea
                  placeholder="Remark"
                  title="Remark"
                  name="remark"
                  onChange={handleInputChange}
                  value={formData.remark}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>
            </div>
          </form>
          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              Update
            </button>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteJvPartner = ({ i, getJvPartner }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/jvpartnerbd/${i.id}/`,
      );

      if (res.status === 200 || res.status === 204) {
        await getJvPartner();
        setShow(false);
        toast.dismiss(loadingToastId);
        toast.success("JvPartner deleted successfully");
      } else {
        // alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete JvPartner"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete JvPartner of {i.partner_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete JvPartner ?
            <div className="button-models">
              <button
                className="model-button   font-weight500    model-button-cancel "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const UploadJvPartner = ({ getJvPartner }) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);
  const bulktableRef = useRef(null);

  // JV Partner Fields
  const fields = [
    "priority_order",
    "partner_name",
    "sector",
    "ops_poc",
    "email",
    "contact_no",
    "senior_poc",
    "senior_contact_no",
    "internal_poc",
    "tncs",
    "remark",
  ];

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setValidationErrors([]);
  };

  // 📥 Download Excel Template
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/bid/tender/26106e67-f10b-4737-aff4-08d010e1c136/tender+sheet28-10-25.xlsx";
    link.download = "JVPartner_Template.xlsx";
    link.click();
  };

  // 📂 Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setDocErrors({});
    if (!file) return;

    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (!validTypes.includes(file.type)) {
      setDocErrors({
        document_file: "Please upload a valid Excel file (.xlsx or .xls).",
      });
      return;
    }

    setFileName(file.name);
    readExcel(file);
  };

  // 📖 Read and parse Excel file
  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      // Validate if required headers exist
      const headers = Object.keys(jsonData[0] || {});
      const missingHeaders = fields.filter((f) => !headers.includes(f));

      // if (missingHeaders.length > 0) {
      //   toast.error(
      //     `❌ Missing headers: ${missingHeaders.join(", ")} in Excel sheet.`,
      //   );
      //   return;
      // }
      console.log(jsonData, 'jsondstaaaa')
      setExcelJson(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  // 🧾 Validate & Upload
  const handleUpload = async () => {
    if (!excelJson) {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
      return;
    }

    const errors = [];
    excelJson.forEach((row, index) => {
      const rowNum = index + 2;
      if (!row.partner_name) errors.push(`Row ${rowNum}: Missing Partner Name`);
      // if (!row.email) errors.push(`Row ${rowNum}: Missing Email`);
      // if (!row.contact_no) errors.push(`Row ${rowNum}: Missing Contact Number`);
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors([]);
    const loadingId = toast.loading("Uploading JV Partners...");

    try {
      const res = await axios.post(
        `${BASE_URL}/siteproject/jvpartnerbulk/`,
        excelJson,
      );
      if (res.status === 200) {
        toast.success("JV Partner data uploaded successfully!");
        getJvPartner(); // refresh table
        handleClose();
      } else {
        toast.error("Upload failed! Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error uploading JV Partner data.");
    } finally {
      toast.dismiss(loadingId);
    }
  };

  const toTitleCase = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      {/* Upload Button */}
      <button
        title="Upload JV Partner"
        className="model-button font-weight500 model-button-print"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          id="upload"
        >
          <g
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Bulk JV Partner Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <button
            onClick={handleDownload}
            className="model-button-download model-button font-weight500"
          >
            Download Format
          </button>

          {/* Preview Table */}
          {excelJson && (
            <div className="table-css-white-background scroll-container mt-3">
              <table className="nested-table-lightblue">
                <thead>
                  <tr>
                    {fields.map((f, i) => (
                      <th key={i}>{toTitleCase(f)}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelJson.map((row, i) => (
                    <tr key={i}>
                      {fields.map((f, j) => (
                        <td key={j}>{row[f]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* File Upload Input */}
          <div className="flex-column field-cont-div mt-3">
            <label className="form-labels font-weight500">Upload File</label>
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
            />
            {fileName && <p className="file-name">{fileName}</p>}
            {docErrors.document_file && (
              <span className="error-message">{docErrors.document_file}</span>
            )}
          </div>

          {/* Buttons */}
          <div className="button-models mt-3">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleUpload}
            >
              Upload
            </button>
          </div>

          {/* Validation Errors */}
          {validationErrors.length > 0 && (
            <div
              style={{
                background: "#ffecec",
                border: "1px solid #f5c2c7",
                color: "#842029",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "15px",
                fontSize: "14px",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <strong>Validation Errors:</strong>
              <ul>
                {validationErrors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>

        <ToastContainer position="top-center" autoClose={1000} />
      </Modal>
    </>
  );
};

const AddAssociatePartner = ({ getJvPartner, JvPartnerData }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormData({
      priority_order: "",
      partner_name: "",
      sector: "",
      ops_poc: "",
      email: "",
      contact_no: "",
      senior_poc: "",
      senior_contact_no: "",
      internal_poc: "",
      tncs: "",
      remark: "",
    });
    setShow(false);
  };
  const handleShow = () => {
    getSubCompany();
    const nextPriority = (JvPartnerData?.length || 0) + 1;

    setFormData((prev) => ({
      ...prev,
      priority_order: nextPriority,
    }));
    setShow(true);
  };
  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const [formData, setFormData] = useState({
    priority_order: "",
    partner_name: "",
    sector: "",
    ops_poc: "",
    email: "",
    contact_no: "",
    senior_poc: "",
    senior_contact_no: "",
    internal_poc: "",
    tncs: "",
    remark: "",
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = ["partner_name", "sector", "email"];

    requiredFields.forEach((field) => {
      console.log(formData[field]);
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    console.log(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.post(
          `${BASE_URL}/siteproject/associatepartner/`,
          formData,
        );

        if (res.status === 200 || res.status === 201) {
          await getJvPartner();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("JvPartner added successfully!");
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add JvPartner!");
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
        console.error(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    } else {
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const finalValue = typeof value === "string" ? value.trim() : value; // ✅ safely handle arrays
    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    // Optional: clear errors on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const [subcompanyList, setSubCompanyList] = useState([]);
  const getSubCompany = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSubCompanyList(response.data);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <button
        title="Add AssociatePartner"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> AssociatePartner
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Add JvPartner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">
              {/* Priority Order */}
              <div className="flex-column">
                <label
                  htmlFor="priority_order"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Priority Order"
                >
                  Priority Order <span className="required">*</span>
                </label>
                <input
                  placeholder="Priority Order"
                  title="Priority Order"
                  type="text"
                  name="priority_order"
                  onChange={handleInputChange}
                  value={formData.priority_order}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Partner Name */}
              <div className="flex-column">
                <label
                  htmlFor="partner_name"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Partner Name"
                >
                  Partner Name<span className="required">*</span>
                </label>
                <input
                  placeholder="Partner Name"
                  title="Partner Name"
                  type="text"
                  name="partner_name"
                  onChange={handleInputChange}
                  value={formData.partner_name}
                  className={`form-input font-weight400 font-size-subheading form-input-background ${errors.partner_name
                    ? "error"
                    : inputState.partner_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.partner_name && (
                  <span className="error-message font-size-text">
                    {errors.partner_name}
                  </span>
                )}
              </div>

              {/* Sector */}
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block" }}
              >
                <label className="form-labels font-weight500 font-size-subheading">
                  Sector <span className="required">*</span>
                </label>
                <br />
                <Select
                  options={[
                    { value: "Highway", label: "Highway" },
                    { value: "Railway", label: "Railway" },
                    { value: "Metro", label: "Metro" },
                    { value: "Water", label: "Water" },
                    { value: "Ropeway", label: "Ropeway" },
                    { value: "Building", label: "Building" },
                    { value: "Other", label: "Other" },
                  ]}
                  isMulti
                  value={
                    Array.isArray(formData.sector)
                      ? formData.sector.map((item) => ({
                        value: item,
                        label: item,
                      }))
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const values = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];
                    handleInputChange({
                      target: { name: "sector", value: values },
                    });
                  }}
                  placeholder="Select Sectors"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                />
                <br />
                {errors.sector && (
                  <span className="error-message">{errors.sector}</span>
                )}
              </div>

              {/* Ops POC */}
              <div className="flex-column">
                <label
                  htmlFor="ops_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Ops POC"
                >
                  Ops POC
                </label>
                <input
                  placeholder="Ops POC"
                  title="Ops POC"
                  type="text"
                  name="ops_poc"
                  onChange={handleInputChange}
                  value={formData.ops_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Email */}
              <div className="flex-column">
                <label
                  htmlFor="email"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Email Id"
                >
                  Email Id <span className="required">*</span>
                </label>
                <input
                  placeholder="Email Id"
                  title="Email Id"
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
                {errors.email && (
                  <span className="error-message font-size-text">
                    {errors.email}
                  </span>
                )}
              </div>

              {/* Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Contact No."
                >
                  Contact No
                </label>
                <input
                  placeholder="Contact No."
                  title="Contact No."
                  type="text"
                  name="contact_no"
                  onChange={handleInputChange}
                  value={formData.contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior POC */}
              <div className="flex-column">
                <label
                  htmlFor="senior_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior POC"
                >
                  Senior POC
                </label>
                <input
                  placeholder="Senior POC"
                  title="Senior POC"
                  type="text"
                  name="senior_poc"
                  onChange={handleInputChange}
                  value={formData.senior_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="senior_contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior Contact No."
                >
                  Senior Contact No
                </label>
                <input
                  placeholder="Senior Contact No."
                  title="Senior Contact No."
                  type="text"
                  name="senior_contact_no"
                  onChange={handleInputChange}
                  value={formData.senior_contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Internal POC */}
              <div className="flex-column">
                <label
                  htmlFor="internal_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Internal POC"
                >
                  Internal POC
                </label>
                <input
                  placeholder="Internal POC"
                  title="Internal POC"
                  type="text"
                  name="internal_poc"
                  onChange={handleInputChange}
                  value={formData.internal_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* TnCs */}
              <div className="flex-column">
                <label
                  htmlFor="tncs"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="TnCs"
                >
                  TnCs
                </label>
                <textarea
                  placeholder="Terms and Conditions"
                  title="TnCs"
                  name="tncs"
                  onChange={handleInputChange}
                  value={formData.tncs}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>

              {/* Remark */}
              <div className="flex-column">
                <label
                  htmlFor="remark"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Remark"
                >
                  Remark
                </label>
                <textarea
                  placeholder="Remark"
                  title="Remark"
                  name="remark"
                  onChange={handleInputChange}
                  value={formData.remark}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>
            </div>
          </form>

          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              Add
            </button>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateAssociatePartner = ({ i, getJvPartner }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormData({
      priority_order: "",
      partner_name: "",
      sector: "",
      ops_poc: "",
      email: "",
      contact_no: "",
      senior_poc: "",
      senior_contact_no: "",
      internal_poc: "",
      tncs: "",
      remark: "",
    });
    setShow(false);
  };
  const handleShow = () => {
    getSubCompany();
    setFormData(i);
    setShow(true);
  };
  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const [formData, setFormData] = useState({
    priority_order: "",
    partner_name: "",
    sector: "",
    ops_poc: "",
    email: "",
    contact_no: "",
    senior_poc: "",
    senior_contact_no: "",
    internal_poc: "",
    tncs: "",
    remark: "",
  });

  // console.log(formData.JvPartner_type)

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      "partner_name",
      "sector",
      "email",

      // formData.JvPartner_type === "Monthbywise" ? "month" : null,
      // formData.JvPartner_type === "Monthbywise" ? "year" : null,
      // formData.JvPartner_type === "ProjectbyWise" ? "project" : null,
      // formData.JvPartner_type === "ProjectbyWise" ? "employee" : null,
    ];

    requiredFields.forEach((field) => {
      console.log(formData[field]);
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    console.log(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/associatepartner/${i.id}/`,
          formData,
        );

        if (res.status === 200) {
          await getJvPartner();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("JvPartner Updated successfully!");
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add JvPartner!");
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    } else {
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const finalValue = typeof value === "string" ? value.trim() : value; // ✅ safely handle arrays
    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    // Optional: clear errors on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const [subcompanyList, setSubCompanyList] = useState([]);
  const getSubCompany = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSubCompanyList(response.data);
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <button
        title="Edit AssociatePartnerDetails"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />{" "}
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Update AssociatePartner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-from">
            <div className="form-flex-wrap">
              {/* Priority Order */}
              <div className="flex-column">
                <label
                  htmlFor="priority_order"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Priority Order"
                >
                  Priority Order <span className="required">*</span>
                </label>
                <input
                  placeholder="Priority Order"
                  title="Priority Order"
                  type="text"
                  name="priority_order"
                  onChange={handleInputChange}
                  value={formData.priority_order}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Partner Name */}
              <div className="flex-column">
                <label
                  htmlFor="partner_name"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Partner Name"
                >
                  Partner Name<span className="required">*</span>
                </label>
                <input
                  placeholder="Partner Name"
                  title="Partner Name"
                  type="text"
                  name="partner_name"
                  onChange={handleInputChange}
                  value={formData.partner_name}
                  className={`form-input font-weight400 font-size-subheading form-input-background ${errors.partner_name
                    ? "error"
                    : inputState.partner_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.partner_name && (
                  <span className="error-message font-size-text">
                    {errors.partner_name}
                  </span>
                )}
              </div>

              {/* Sector */}
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block" }}
              >
                <label className="form-labels font-weight500 font-size-subheading">
                  Sector <span className="required">*</span>
                </label>
                <br />
                <Select
                  options={[
                    { value: "Highway", label: "Highway" },
                    { value: "Railway", label: "Railway" },
                    { value: "Metro", label: "Metro" },
                    { value: "Water", label: "Water" },
                    { value: "Ropeway", label: "Ropeway" },
                    { value: "Building", label: "Building" },
                    { value: "Other", label: "Other" },
                  ]}
                  isMulti
                  value={
                    Array.isArray(formData.sector)
                      ? formData.sector.map((item) => ({
                        value: item,
                        label: item,
                      }))
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const values = selectedOptions
                      ? selectedOptions.map((opt) => opt.value)
                      : [];
                    handleInputChange({
                      target: { name: "sector", value: values },
                    });
                  }}
                  placeholder="Select Sectors"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                />
                <br />
                {errors.sector && (
                  <span className="error-message">{errors.sector}</span>
                )}
              </div>

              {/* Ops POC */}
              <div className="flex-column">
                <label
                  htmlFor="ops_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Ops POC"
                >
                  Ops POC
                </label>
                <input
                  placeholder="Ops POC"
                  title="Ops POC"
                  type="text"
                  name="ops_poc"
                  onChange={handleInputChange}
                  value={formData.ops_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Email */}
              <div className="flex-column">
                <label
                  htmlFor="email"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Email Id"
                >
                  Email Id <span className="required">*</span>
                </label>
                <input
                  placeholder="Email Id"
                  title="Email Id"
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  value={formData.email}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
                {errors.email && (
                  <span className="error-message font-size-text">
                    {errors.email}
                  </span>
                )}
              </div>

              {/* Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Contact No."
                >
                  Contact No
                </label>
                <input
                  placeholder="Contact No."
                  title="Contact No."
                  type="text"
                  name="contact_no"
                  onChange={handleInputChange}
                  value={formData.contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior POC */}
              <div className="flex-column">
                <label
                  htmlFor="senior_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior POC"
                >
                  Senior POC
                </label>
                <input
                  placeholder="Senior POC"
                  title="Senior POC"
                  type="text"
                  name="senior_poc"
                  onChange={handleInputChange}
                  value={formData.senior_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Senior Contact No. */}
              <div className="flex-column">
                <label
                  htmlFor="senior_contact_no"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Senior Contact No."
                >
                  Senior Contact No
                </label>
                <input
                  placeholder="Senior Contact No."
                  title="Senior Contact No."
                  type="text"
                  name="senior_contact_no"
                  onChange={handleInputChange}
                  value={formData.senior_contact_no}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* Internal POC */}
              <div className="flex-column">
                <label
                  htmlFor="internal_poc"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Internal POC"
                >
                  Internal POC
                </label>
                <input
                  placeholder="Internal POC"
                  title="Internal POC"
                  type="text"
                  name="internal_poc"
                  onChange={handleInputChange}
                  value={formData.internal_poc}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                />
              </div>

              {/* TnCs */}
              <div className="flex-column">
                <label
                  htmlFor="tncs"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="TnCs"
                >
                  TnCs
                </label>
                <textarea
                  placeholder="Terms and Conditions"
                  title="TnCs"
                  name="tncs"
                  onChange={handleInputChange}
                  value={formData.tncs}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>

              {/* Remark */}
              <div className="flex-column">
                <label
                  htmlFor="remark"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  title="Remark"
                >
                  Remark
                </label>
                <textarea
                  placeholder="Remark"
                  title="Remark"
                  name="remark"
                  onChange={handleInputChange}
                  value={formData.remark}
                  className="form-input font-weight400 font-size-subheading form-input-background"
                  rows={2}
                />
              </div>
            </div>
          </form>
          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              Update
            </button>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteAssociatePartner = ({ i, getJvPartner }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/associatepartner/${i.id}/`,
      );

      if (res.status === 200 || res.status === 204) {
        await getJvPartner();
        setShow(false);
        toast.dismiss(loadingToastId);
        toast.success("JvPartner deleted successfully");
      } else {
        // alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete AssociatePartner"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete AssociatePartner of {i.partner_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete AssociatePartner ?
            <div className="button-models">
              <button
                className="model-button   font-weight500    model-button-cancel "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const UploadAssociatePartner = ({ getJvPartner }) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null);
  const [docErrors, setDocErrors] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);
  const bulktableRef = useRef(null);

  // JV Partner Fields
  const fields = [
    "priority_order",
    "partner_name",
    "sector",
    "ops_poc",
    "email",
    "contact_no",
    "senior_poc",
    "senior_contact_no",
    "internal_poc",
    "tncs",
    "remark",
  ];

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setValidationErrors([]);
  };

  // 📥 Download Excel Template
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/bid/tender/26106e67-f10b-4737-aff4-08d010e1c136/tender+sheet28-10-25.xlsx";
    link.download = "JVPartner_Template.xlsx";
    link.click();
  };

  // 📂 Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setDocErrors({});
    if (!file) return;

    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (!validTypes.includes(file.type)) {
      setDocErrors({
        document_file: "Please upload a valid Excel file (.xlsx or .xls).",
      });
      return;
    }

    setFileName(file.name);
    readExcel(file);
  };

  // 📖 Read and parse Excel file
  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      // Validate if required headers exist
      const headers = Object.keys(jsonData[0] || {});
      const missingHeaders = fields.filter((f) => !headers.includes(f));

      if (missingHeaders.length > 0) {
        toast.error(
          `❌ Missing headers: ${missingHeaders.join(", ")} in Excel sheet.`,
        );
        return;
      }

      setExcelJson(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  // 🧾 Validate & Upload
  const handleUpload = async () => {
    if (!excelJson) {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
      return;
    }

    const errors = [];
    excelJson.forEach((row, index) => {
      const rowNum = index + 2;
      if (!row.partner_name) errors.push(`Row ${rowNum}: Missing Partner Name`);
      // if (!row.email) errors.push(`Row ${rowNum}: Missing Email`);
      // if (!row.contact_no) errors.push(`Row ${rowNum}: Missing Contact Number`);
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors([]);
    const loadingId = toast.loading("Uploading JV Partners...");

    try {
      const res = await axios.post(
        `${BASE_URL}/siteproject/associatepartnerbulk/`,
        excelJson,
      );
      if (res.status === 200 || res.status === 201) {
        toast.success("JV Partner data uploaded successfully!");
        getJvPartner(); // refresh table
        handleClose();
      } else {
        toast.error("Upload failed! Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error uploading JV Partner data.");
    } finally {
      toast.dismiss(loadingId);
    }
  };

  const toTitleCase = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      {/* Upload Button */}
      <button
        title="Upload AssociatePartner"
        className="model-button font-weight500 model-button-print"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          id="upload"
        >
          <g
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Bulk AssociatePartner Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <button
            onClick={handleDownload}
            className="model-button-download model-button font-weight500"
          >
            Download Format
          </button>

          {/* Preview Table */}
          {excelJson && (
            <div className="table-css-white-background scroll-container mt-3">
              <table className="nested-table-lightblue">
                <thead>
                  <tr>
                    {fields.map((f, i) => (
                      <th key={i}>{toTitleCase(f)}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelJson.map((row, i) => (
                    <tr key={i}>
                      {fields.map((f, j) => (
                        <td key={j}>{row[f]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* File Upload Input */}
          <div className="flex-column field-cont-div mt-3">
            <label className="form-labels font-weight500">Upload File</label>
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
            />
            {fileName && <p className="file-name">{fileName}</p>}
            {docErrors.document_file && (
              <span className="error-message">{docErrors.document_file}</span>
            )}
          </div>

          {/* Buttons */}
          <div className="button-models mt-3">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleUpload}
            >
              Upload
            </button>
          </div>

          {/* Validation Errors */}
          {validationErrors.length > 0 && (
            <div
              style={{
                background: "#ffecec",
                border: "1px solid #f5c2c7",
                color: "#842029",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "15px",
                fontSize: "14px",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <strong>Validation Errors:</strong>
              <ul>
                {validationErrors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>

        <ToastContainer position="top-center" autoClose={1000} />
      </Modal>
    </>
  );
};

const JvPartner = () => {
  const [buffer, setBuffering] = useState(true);
  const tableRef = useRef(null);
  const [JvPartnerData, setJvPartnerData] = useState([]);

  const getJvPartner = async (filters) => {
    setBuffering(true);
    try {
      // 🧠 Replace with your actual API endpoint
      const res = await axios.get(`${BASE_URL}/siteproject/jvpartnerbd/`);

      // Assuming API returns a list of JV Partner data
      setJvPartnerData(res.data);
    } catch (err) {
      console.error("Error fetching JV Partner data:", err);
    } finally {
      setBuffering(false);
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setIsCollapsed(!isCollapsed);
  };

  const [filters, setFilters] = useState({
    searchInternalPoc: "",
    searchPartner: "",
    category: "",
  });

  const categories = [
    "Highway",
    "Railway",
    "Metro",
    "Water",
    "Ropeway",
    "Building",
  ];
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [isclear, Setisclear] = useState(false);
  const [issubmit, SetIsSubmit] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    SetIsSubmit(true);
  };

  const handleClear = () => {
    setFilters({
      searchInternalPoc: "",
      searchPartner: "",
      category: "",
    });
    Setisclear(true);
  };

  useEffect(() => {
    if (isclear) {
    }
  }, [isclear]);
  useEffect(() => {
    getJvPartner();
  }, []);
  useEffect(() => {
    if (issubmit) {
      getJvPartner();
    }
  }, [filters, issubmit]);

  const [filteredData, setFilteredData] = useState([]);
  const applyFilters = () => {
    let filteredData = JvPartnerData;
    if (filters.searchPartner !== "") {
      const lowercaseSelectedName = filters.searchPartner.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const name = project.partner_name
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return name;
      });
    }
    if (filters.searchInternalPoc != "") {
      filteredData = filteredData.filter(
        (project) => project.internal_poc === filters.searchInternalPoc,
      );
    }
    if (filters.category !== "") {
      filteredData = filteredData.filter((project) => {
        const sector = project.sector;

        if (Array.isArray(sector)) {
          return sector.some(
            (sec) => sec.toLowerCase() === filters.category.toLowerCase(),
          );
        }

        if (typeof sector === "string") {
          return sector.toLowerCase() === filters.category.toLowerCase();
        }

        return false;
      });
    }

    console.log(filteredData, "filterdata");
    setFilteredData(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [filters, JvPartnerData]);
  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} />

      <div className="attendance-history-cont">
        <div className="field-cont">
          <div
            className="attendance-subcontainer"
            style={{ width: "100%", padding: "0px 0px 0px 0px" }}
          >
            <div
              className="flex-row"
              style={{
                width: "100%",
                justifyContent: "end",
                padding: "10px",
                gap: "5px",
              }}
            ></div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                padding: "10px",
                gap: "5px",
              }}
            >
              <AddJvPartner
                getJvPartner={getJvPartner}
                JvPartnerData={JvPartnerData}
              />
              <UploadJvPartner getJvPartner={getJvPartner} />
            </div>
          </div>
        </div>
        <div className="filters-card">
          <div
            className="filters-header"
            onClick={toggleCollapse}
            role="button"
          >
            <h3 className="filters-title">Filters</h3>
            <button className="collapse-btn" aria-label="toggle filters">
              {isCollapsed ? (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M18 15L12 9L6 15"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>

          {!isCollapsed && (
            <form onSubmit={handleSubmit} className="filters-form">
              {/* SEARCH (full width) */}
              <div className="filter-row full-width">
                <div className="field-wrapper search-wrapper">
                  <label htmlFor="searchText" className="filter-label">
                    Search By Partner Name
                  </label>
                  <div className="input-with-icon">
                    <svg
                      className="icon search-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path
                        fill="none"
                        stroke="#9fbfe8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                      />
                    </svg>
                    <input
                      id="searchPartner"
                      name="searchPartner"
                      value={filters.searchPartner || ""}
                      onChange={handleChange}
                      placeholder="Search by Partner Name"
                      className="filter-input search-input"
                      style={{ width: "90%" }}
                    />
                  </div>
                </div>
                <div className="field-wrapper search-wrapper">
                  <label htmlFor="searchText" className="filter-label">
                    Search By InternalPoc Name
                  </label>
                  <div className="input-with-icon">
                    <svg
                      className="icon search-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path
                        fill="none"
                        stroke="#9fbfe8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                      />
                    </svg>
                    <input
                      id="searchInternalPoc"
                      name="searchInternalPoc"
                      value={filters.searchInternalPoc || ""}
                      onChange={handleChange}
                      placeholder="Search by InternalPoc Name"
                      className="filter-input search-input"
                      style={{ width: "90%" }}
                    />
                  </div>
                </div>
                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">Sectors</label>
                  <select
                    name="category"
                    value={filters.category || ""}
                    onChange={handleChange}
                    className="filter-input select-input"
                  >
                    <option value="">Select Sectors</option>
                    {categories.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="filter-actions">
                <button
                  type="submit"
                  className="btn btn-primary btn-color"
                  style={{ background: "#2576bc" }}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-color-white"
                  style={{
                    background: "#fff",
                    border: "1px solid #2576bc",
                    color: "#2576bc",
                  }}
                  onClick={handleClear}
                >
                  Clear
                </button>
              </div>
            </form>
          )}
        </div>
        <div
          className="table-css-white-background table-box paddingTop-0px scroll-container-table"
          style={{ minHeight: "380px" }}
        >
          <table ref={tableRef} className="table-css">
            <thead className="table-heading">
              <tr className="custom-table-head-tr">
                <th className="align-left">Priority Order</th>
                <th className="align-center">Partner Name</th>
                <th className="align-center">Sector</th>
                <th className="align-center">Ops POC</th>
                <th className="align-center">Email Id</th>
                <th className="align-center">Contact No.</th>
                <th className="align-center">Senior POC</th>
                <th className="align-center">Contact No.</th>
                <th className="align-center">Internal POC</th>
                <th className="align-center">TnCs</th>
                <th className="align-center">Remark</th>
                <th className="align-center width-5vw">Action</th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner-bgdatil"></div>
            ) : (
              <tbody>
                {filteredData.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="12"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{i.priority_order}</td>
                      <td className="align-center">{i.partner_name}</td>
                      <td className="align-center">
                        {Array.isArray(i.sector)
                          ? i.sector.join(", ")
                          : i.sector}
                      </td>

                      <td className="align-center">{i.ops_poc}</td>
                      <td className="align-center">{i.email}</td>
                      <td className="align-center">{i.contact_no}</td>
                      <td className="align-center">{i.senior_poc}</td>
                      <td className="align-center">{i.senior_contact}</td>
                      <td className="align-center">{i.internal_poc}</td>
                      <td className="align-center">{i.tncs}</td>
                      <td className="align-center">{i.remark}</td>

                      <td className="align-center">
                        <div className="flex-row justify-evenly">
                          <UpdateJvPartner i={i} getJvPartner={getJvPartner} />
                          <DeleteJvPartner i={i} getJvPartner={getJvPartner} />
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const AssociatePartner = () => {
  const [buffer, setBuffering] = useState(true);
  const tableRef = useRef(null);
  const [JvPartnerData, setJvPartnerData] = useState([]);

  const getJvPartner = async (filters) => {
    setBuffering(true);
    try {
      // 🧠 Replace with your actual API endpoint
      const res = await axios.get(`${BASE_URL}/siteproject/associatepartner/`);

      // Assuming API returns a list of JV Partner data
      setJvPartnerData(res.data);
    } catch (err) {
      console.error("Error fetching JV Partner data:", err);
    } finally {
      setBuffering(false);
    }
  };

  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setIsCollapsed(!isCollapsed);
  };

  const [filters, setFilters] = useState({
    searchInternalPoc: "",
    searchPartner: "",
    category: "",
  });

  const categories = [
    "Highway",
    "Railway",
    "Water",
    "Metro",
    "Urban Infrastructure Buildings",
  ];
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [isclear, Setisclear] = useState(false);
  const [issubmit, SetIsSubmit] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    SetIsSubmit(true);
  };

  const handleClear = () => {
    setFilters({
      searchInternalPoc: "",
      searchPartner: "",
      category: "",
    });
    Setisclear(true);
  };

  useEffect(() => {
    if (isclear) {
    }
  }, [isclear]);
  useEffect(() => {
    getJvPartner();
  }, []);
  useEffect(() => {
    if (issubmit) {
      getJvPartner();
    }
  }, [filters, issubmit]);

  const [filteredData, setFilteredData] = useState([]);
  const applyFilters = () => {
    let filteredData = JvPartnerData;
    if (filters.searchPartner !== "") {
      const lowercaseSelectedName = filters.searchPartner.toLowerCase();
      filteredData = filteredData.filter((project) => {
        const name = project.partner_name
          .toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return name;
      });
    }
    if (filters.searchInternalPoc != "") {
      filteredData = filteredData.filter(
        (project) => project.internal_poc === filters.searchInternalPoc,
      );
    }
    if (filters.category !== "") {
      filteredData = filteredData.filter((project) => {
        const sector = project.sector;

        if (Array.isArray(sector)) {
          return sector.some(
            (sec) => sec.toLowerCase() === filters.category.toLowerCase(),
          );
        }

        if (typeof sector === "string") {
          return sector.toLowerCase() === filters.category.toLowerCase();
        }

        return false;
      });
    }
    console.log(filteredData, "filterdata");
    setFilteredData(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [filters, JvPartnerData]);
  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} />

      <div className="attendance-history-cont">
        <div className="field-cont">
          <div className="attendance-subcontainer" style={{ width: "100%" }}>
            <div
              className="flex-row"
              style={{ width: "80%", flexWrap: "wrap" }}
            ></div>
            <div className="flex-row">
              <AddAssociatePartner
                getJvPartner={getJvPartner}
                JvPartnerData={JvPartnerData}
              />
              <UploadAssociatePartner getJvPartner={getJvPartner} />
            </div>
          </div>
        </div>
        <div className="filters-card">
          <div
            className="filters-header"
            onClick={toggleCollapse}
            role="button"
          >
            <h3 className="filters-title">Filters</h3>
            <button className="collapse-btn" aria-label="toggle filters">
              {isCollapsed ? (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M18 15L12 9L6 15"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>

          {!isCollapsed && (
            <form onSubmit={handleSubmit} className="filters-form">
              {/* SEARCH (full width) */}
              <div className="filter-row full-width">
                <div className="field-wrapper search-wrapper">
                  <label htmlFor="searchText" className="filter-label">
                    Search By Partner Name
                  </label>
                  <div className="input-with-icon">
                    <svg
                      className="icon search-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path
                        fill="none"
                        stroke="#9fbfe8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                      />
                    </svg>
                    <input
                      id="searchPartner"
                      name="searchPartner"
                      value={filters.searchPartner || ""}
                      onChange={handleChange}
                      placeholder="Search by Partner Name"
                      className="filter-input search-input"
                      style={{ width: "90%" }}
                    />
                  </div>
                </div>
                <div className="field-wrapper search-wrapper">
                  <label htmlFor="searchText" className="filter-label">
                    Search By InternalPoc Name
                  </label>
                  <div className="input-with-icon">
                    <svg
                      className="icon search-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path
                        fill="none"
                        stroke="#9fbfe8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                      />
                    </svg>
                    <input
                      id="searchInternalPoc"
                      name="searchInternalPoc"
                      value={filters.searchInternalPoc || ""}
                      onChange={handleChange}
                      placeholder="Search by InternalPoc Name"
                      className="filter-input search-input"
                      style={{ width: "90%" }}
                    />
                  </div>
                </div>
                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">Sectors</label>
                  <select
                    name="category"
                    value={filters.category || ""}
                    onChange={handleChange}
                    className="filter-input select-input"
                  >
                    <option value="">Select Sectors</option>
                    {categories.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="filter-actions">
                <button
                  type="submit"
                  className="btn btn-primary btn-color"
                  style={{ background: "#2576bc" }}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-color-white"
                  style={{
                    background: "#fff",
                    border: "1px solid #2576bc",
                    color: "#2576bc",
                  }}
                  onClick={handleClear}
                >
                  Clear
                </button>
              </div>
            </form>
          )}
        </div>
        <div
          className="table-css-white-background table-box paddingTop-0px scroll-container-table"
          style={{ minHeight: "380px" }}
        >
          <table ref={tableRef} className="table-css">
            <thead className="table-heading">
              <tr className="custom-table-head-tr">
                <th className="align-left">Priority Order</th>
                <th className="align-center">Partner Name</th>
                <th className="align-center">Sector</th>
                <th className="align-center">Ops POC</th>
                <th className="align-center">Email Id</th>
                <th className="align-center">Contact No.</th>
                <th className="align-center">Senior POC</th>
                <th className="align-center">Contact No.</th>
                <th className="align-center">Internal POC</th>
                <th className="align-center">TnCs</th>
                <th className="align-center">Remark</th>
                <th className="align-center width-5vw">Action</th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner-bgdatil"></div>
            ) : (
              <tbody>
                {filteredData.map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="12"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{i.priority_order}</td>
                      <td className="align-center">{i.partner_name}</td>
                      <td className="align-center">
                        {Array.isArray(i.sector)
                          ? i.sector.join(", ")
                          : i.sector}
                      </td>

                      <td className="align-center">{i.ops_poc}</td>
                      <td className="align-center">{i.email}</td>
                      <td className="align-center">{i.contact_no}</td>
                      <td className="align-center">{i.senior_poc}</td>
                      <td className="align-center">{i.senior_contact}</td>
                      <td className="align-center">{i.internal_poc}</td>
                      <td className="align-center">{i.tncs}</td>
                      <td className="align-center">{i.remark}</td>

                      <td className="align-center">
                        <div className="flex-row justify-evenly">
                          <UpdateAssociatePartner
                            i={i}
                            getJvPartner={getJvPartner}
                          />
                          <DeleteAssociatePartner
                            i={i}
                            getJvPartner={getJvPartner}
                          />
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

const PartnerManagement = () => {
  const [toggleState, setToggleState] = useState(1);

  return (
    <div>
      <Dashboardnavbar
        name={toggleState === 1 ? "Jv Partner" : "Associate Partner"}
        url="Partner Management"
      />

      <div className="content-tabs">
        <div
          className="toggle-button-area flex-row justify-between"
          style={{ padding: "15px 30px" }}
        >
          <div>
            <button
              className={
                toggleState === 1
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
              }
              onClick={() => setToggleState(1)}
            >
              Jv Partner
            </button>

            <button
              className={
                toggleState === 2
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
              }
              onClick={() => setToggleState(2)}
            >
              Associate Partner
            </button>
          </div>
        </div>
      </div>

      <div className="content-tabs">
        {toggleState === 1 ? <JvPartner /> : null}
        {toggleState === 2 ? <AssociatePartner /> : null}
      </div>
    </div>
  );
};
export default PartnerManagement;
